import CryptoJS from 'crypto-js';

const aesKey = '651cc172938d5b7799a23ac245e539a6';
const aesIv = '35e5cd2d684e5c65';

//解密啊
const encrypt = (data: any) => {
  let stringData = data;
  if (typeof data === 'object') {
    try {
      // eslint-disable-next-line no-param-reassign
      stringData = JSON.stringify(data);
    } catch (error) {
      console.log('encrypt error:', error);
    }
  }
  const key = CryptoJS.enc.Utf8.parse(aesKey);
  const iv = CryptoJS.enc.Utf8.parse(aesIv);
  const encrypted = CryptoJS.AES.encrypt(stringData, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
};

export default encrypt;
